import {
  filterScopeNavigatorTasks,
  type ScopeAttentionFilterContext,
  type ScopeFilterKey,
} from '@/Client/Lib/scopeAttentionFilterLib';
import {
  getTasksInStandardSortOrder,
  type ScanGroupOptimized,
  type ScanTaskOptimized,
} from '@kaiizen/kai-scan-template-system';

export const TASK_NAME_MAX_LENGTH = 50;

export const truncateGroupTaskListName = (name: string, maxLength = TASK_NAME_MAX_LENGTH): string =>
  name.length > maxLength ? `${name.slice(0, maxLength).trimEnd()}…` : name;

/** Tasks visible in the overview list, respecting navigator filters and standard sort order. */
export const getGroupTaskListViewTasks = (
  group: ScanGroupOptimized,
  activeFilters: ReadonlySet<ScopeFilterKey>,
  evalContext: ScopeAttentionFilterContext,
  filterRegex?: RegExp,
): ScanTaskOptimized[] => {
  const visibleTasks = filterScopeNavigatorTasks(group.tasks ?? [], activeFilters, evalContext);
  const { clusterOrder, taskClusters } = getTasksInStandardSortOrder(
    group.template,
    visibleTasks,
    filterRegex,
  );
  return clusterOrder.flatMap(category => taskClusters[category] ?? []);
};
